import { AffectedProduct } from '../../../../../../types';

/** Gets the score text in the form of `base / temporal` */
export const getScoreText = (
  product:
    | Partial<Pick<AffectedProduct, 'baseScore' | 'temporalScore'>>
    | undefined
) => {
  // This is intentionally asymmetric. If there's no base score, don't show a temporal score either.
  if (!product?.baseScore) {
    return '';
  }
  if (!product.temporalScore) {
    return product.baseScore;
  }
  const { baseScore, temporalScore } = product;
  return `${baseScore} / ${temporalScore}`;
};
